import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as api from '@/api/api'

// 引入弹窗组件
import SkUserPopup from '@/components/common/sk-user-popup.vue'
import SkPrivacyPopup from '@/components/common/sk-privacy-popup.vue'
// Ant Design Vue 组件 & 图标
import {
  Button, Form, Input, message, Modal, Table, Checkbox,
  ConfigProvider, Tag, InputNumber, Cascader, Image,
  Spin, Upload, DatePicker, Tabs
} from 'ant-design-vue'
import { PlusOutlined, EnvironmentOutlined } from '@ant-design/icons-vue'

// 全局屏蔽 ResizeObserver 循环报错（防抖优化）
const debounce = (fn, delay = 20) => {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}
window.ResizeObserver = class extends window.ResizeObserver {
  constructor(callback) {
    super(debounce(callback))
  }
}

const app = createApp(App)

// ========== 全局注册公共组件 ==========
app.component('SkUserPopup', SkUserPopup)
app.component('SkPrivacyPopup', SkPrivacyPopup)
// 使用规范：template中 <SkUserPopup /> 大小写对应

// 全局挂载 API 和消息提示
app.config.globalProperties.$api = api
app.config.globalProperties.$message = message
window.$message = message

// 批量注册 Antd 组件
const components = [
  Button, Form, Input, Modal, Table, Checkbox,
  ConfigProvider, Tag, InputNumber, Cascader, Image,
  Spin, Upload, DatePicker, Tabs
]
components.forEach(component => {
  app.use(component)
})

// 批量注册图标
const icons = [PlusOutlined, EnvironmentOutlined]
icons.forEach(icon => {
  app.component(icon.name, icon)
})

// 全局注入
app.provide('Message', message)
app.provide('Modal', Modal)

// 挂载应用
app.use(store).use(router).mount('#app')